import { usersService } from '@/services/apiRequests/users.service';
import { refsService } from '@/services/apiRequests/refs.service';
import { LocaleService } from '@/services/storage.service';

export default {
    namespaced: true,
    state: {
        userList: [],
        userListLength: 0,
        userListLoading: false,
        formListPagination: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 10,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        servOrgList: [],
        roleList: [],
        currentUser: '',
        filter: null,
        servOrg: {},
        userHeader: {},
        userInfo: {},
        userRoles: [],
        contractList: [],
        kskList: [],
        categoryList: [],
        rolesCategoryList: [],
        itemsEngineer: [],
        KSK: [],
        KSKLength: 0,
        Contract: [],
        ContractLength: 0,
        SelectedKSK: {},
        SelectedContract: {}
    },
    mutations: {
        setSelectedKSK(state, SelectedKSK) {
            state.SelectedKSK = SelectedKSK;
            state.kskList = [SelectedKSK];
        },
        setSelectedContract(state, SelectedContract) {
            state.SelectedContract = SelectedContract;
            state.contractList = [SelectedContract];
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setUserRoles(state, userRoles) {
            state.userRoles = userRoles;
        },
        setUserList(state, userList) {
            state.userList = userList;
        },
        setUserListLength(state, userListLength) {
            state.userListLength = Number(userListLength);
        },
        setUserListLoading(state, userListLoading) {
            state.userListLoading = userListLoading;
        },
        setFormListPagination(state, formListPagination) {
            state.formListPagination = formListPagination;
        },
        setServOrgList(state, servOrgList) {
            state.servOrgList = servOrgList;
        },
        setRoleList(state, roleList) {
            state.roleList = roleList;
        },
        setCurrentUser(state, currentUser) {
            state.currentUser = currentUser;
        },
        setFilter(state, filter) {
            state.filter = filter;
            state.formListPagination.page = 1;
        },
        setServOrg(state, servOrg) {
            state.servOrg = servOrg;
        },
        setUserHeader(state, userHeader) {
            state.userHeader = userHeader;
        },
        setContractList(state, contractList) {
            state.contractList = contractList;
        },
        setKSKList(state, kskList) {
            state.kskList = kskList;
        },
        setCategoryList(state, categoryList) {
            state.categoryList = categoryList;
        },
        setRolesCategoryList(state, rolesCategoryList) {
            state.rolesCategoryList = rolesCategoryList;
        },
        setitemsEngineer(state, itemsEngineer) {
            state.itemsEngineer = itemsEngineer;
        },
        setKSK(state, KSK) {
            state.KSK = KSK;
        },
        setKSKLength(state, KSKLength) {
            state.KSKLength = KSKLength;
        },
        setContract(state, Contract) {
            state.Contract = Contract;
        },
        setContractLength(state, ContractLength) {
            state.ContractLength = ContractLength;
        }
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo;
        }
    },
    actions: {
        async saveUser(
            { state },
            { user_id, email, name, isas_serv_org_rid, roles_rid, isas_ksk_rid, isas_contract_rid, category_rid, isas_engineer_rid, isas_contractor_rid }
        ) {
            try {
                return await usersService.saveUser(
                    user_id,
                    email,
                    name,
                    isas_serv_org_rid,
                    roles_rid,
                    isas_ksk_rid,
                    isas_contract_rid,
                    category_rid,
                    isas_engineer_rid,
                    isas_contractor_rid
                );
            } catch (e) {
                console.error(e);
            }
        },
        async newUser(
            { state },
            { email, name, isas_serv_org_rid, roles_rid, isas_ksk_rid, isas_contract_rid, category_rid, isas_engineer_rid, isas_contractor_rid }
        ) {
            try {
                return await usersService.signupWithActivation(
                    email,
                    name,
                    isas_serv_org_rid,
                    roles_rid,
                    isas_ksk_rid,
                    isas_contract_rid,
                    category_rid,
                    isas_engineer_rid,
                    isas_contractor_rid
                );
            } catch (e) {
                console.error(e);
            }
        },
        async updateIsActive({ state }, { user_id, active }) {
            try {
                const res = await usersService.updateIsActive(user_id, active);
                if (res.successfull) {
                    state.userList.find(x => x.record_id === user_id).active = active;
                    //удалим сессию пользователя
                    if (!active) {
                        await usersService.deleteUserSession(user_id);
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getUserList({ commit, state, dispatch }) {
            try {
                commit('setUserListLength', 0);
                commit('setUserListLoading', true);
                const options = state.formListPagination;
                let response;
                if (options.sortBy[0] || state.filter) {
                    const locale = LocaleService.getLocale();
                    // определяем язык интерфейса
                    const JSONToSend = {
                        locale: locale === 'ru' ? '___ru' : '___kz'
                    };
                    // Если задана сортировака
                    if (options.sortBy[0]) {
                        JSONToSend.order = [{ field: options.sortBy[0], order_by: options.sortDesc[0] === true ? 'desc' : 'asc' }];
                    }
                    // если задан фильтр
                    if (state.filter) {
                        JSONToSend.where = state.filter.where;
                    }
                    // функция с возможностью сортировки и фильтрации. Отправляем JSON с данными по фильтрации и сортировки

                    response = await usersService.getUserListFilter(options.itemsPerPage, options.itemsPerPage * (options.page - 1), JSONToSend);
                } else {
                    // функция без JSON'а. Используется когда страница только загрузилась, и когда фильтр или сортировка не заданы
                    response = await usersService.getUserList(options.itemsPerPage, options.itemsPerPage * (options.page - 1));
                }

                if (response.successfull) {
                    response.data.forEach(element => {
                        //добавим поле сервисная организация
                        element.isas_serv_org_name = { isas_serv_org_name___ru: '', isas_serv_org_name___kz: '' };
                        element.canDeactivate = true;
                    });
                    commit('setUserList', response.data);
                    if (response.data[0]) {
                        commit('setUserListLength', response.data[0].record_count);
                    }
                }

                await dispatch('getServOrgList'); // TODO: нужно ли это здесь? отрефакторить

                //а здесь проставим его значение из справочника
                if (state.userList && state.servOrgList) {
                    state.userList.forEach(element => {
                        if (element.user_data && element.user_data.isas_serv_org_rid && element.user_data.isas_serv_org_rid > 0) {
                            const servOrg = state.servOrgList.find(x => x.isas_serv_org_rid === element.user_data.isas_serv_org_rid);
                            if (servOrg) {
                                element.isas_serv_org_name = {
                                    isas_serv_org_name___ru: servOrg.isas_serv_org_name___ru,
                                    isas_serv_org_name___kz: servOrg.isas_serv_org_name___kz
                                };
                            }
                        }
                    });
                }
                await dispatch('getCurrentUser');
                const checkCurUser = state.userList.find(x => x.record_id === state.currentUser);
                if (checkCurUser) {
                    checkCurUser.canDeactivate = false;
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('setUserListLoading', false);
            }
        },
        async getUserInfo({ commit, state, dispatch }) {
            await dispatch('getServOrgList');
            await dispatch('getCurrentUser');
            try {
                const userInfo = await usersService.getUserInfo(state.currentUser);
                if (userInfo.successfull) {
                    commit('setUserInfo', userInfo.data);
                }
                state.userInfo.isas_serv_org_name = { isas_serv_org_name___ru: '', isas_serv_org_name___kz: '' };
                const servOrg = state.servOrgList.find(x => x.isas_serv_org_rid === state.userInfo.user_data.isas_serv_org_rid);
                if (servOrg) {
                    state.userInfo.isas_serv_org_name = {
                        isas_serv_org_name___ru: servOrg.isas_serv_org_name___ru,
                        isas_serv_org_name___kz: servOrg.isas_serv_org_name___kz
                    };
                }
                const engineerRid = userInfo.data.user_data.isas_engineer_rid;
                if (engineerRid) commit('prescription/setiengineer_rid', engineerRid, { root: true });
            } catch (e) {
                console.error(e);
            }
        },
        async getServOrgList({ commit }) {
            try {
                const servOrg = await refsService.getServOrgList(0, 0);
                if (servOrg.successfull) {
                    commit('setServOrgList', servOrg.data.isas_serv_orgs);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getCurrentUser({ commit }) {
            try {
                const res = await usersService.getCurUser();
                if (res.successfull) {
                    commit('setCurrentUser', res.data);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getRoleList({ commit }) {
            try {
                const res = await refsService.getRoleList(0, 0);
                if (res.successfull) {
                    commit('setRoleList', res.data);
                }
            } catch (e) {
                console.error(e);
            }
        },

        setUserRoles({ state, commit }) {
            const allRoles = state.roleList;
            const userRoleRids = state.userInfo.role_rid;
            const userRoles = allRoles.filter(role => userRoleRids.includes(role.record_id));
            commit('setUserRoles', userRoles);
        },

        async getServOrg({ commit }) {
            let servOrg = {};
            try {
                const res = await refsService.getServOrgById();
                if (!res || !res.successfull) return;
                servOrg = res.data;
            } catch (e) {
                console.error(e);
            } finally {
                commit('setServOrg', servOrg);
            }
        },
        async getUserHeader({ commit }) {
            let userHeader = {};
            try {
                const res = await refsService.getUserHeaderById();
                if (!res || !res.successfull) return;
                userHeader = res.data;
            } catch (e) {
                console.error(e);
            } finally {
                commit('setUserHeader', userHeader);
            }
        },
        async getContractList({ commit }) {
            try {
                let res = await refsService.getContractList(0, 0);
                if (res.successfull) {
                    commit('setContractList', res.data.isas_contracts);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getKSKList({ commit }) {
            try {
                let res = await refsService.getKSKList(0, 0);
                if (res.successfull) {
                    commit('setKSKList', res.data.isas_ksk);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getCategoryList({ commit }) {
            try {
                let res = await refsService.getCategoryList(0, 0);
                if (res.successfull) {
                    commit('setCategoryList', res.data);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getRolesCategoryList({ commit }) {
            try {
                let res = await refsService.getRolesCategoryList(0, 0);
                if (res.successfull) {
                    commit('setRolesCategoryList', res.data);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getEngList({ commit }) {
            try {
                const list = await refsService.getEngList(0, 0);
                if (list.successfull) {
                    commit('setitemsEngineer', list.data.isas_engineer);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getKSK({ commit }, { req }) {
            let KSK = [];
            let setKSKLength = 0;
            try {
                const res = await refsService.getKSK(req);
                if (!res || !res.successfull) return;
                KSK = res.data.isas_ksk ? res.data.isas_ksk : [];
                if (res.data && res.data.pagination && res.data.pagination.row_count) setKSKLength = res.data.pagination.row_count;
            } catch (e) {
                console.error(e);
            } finally {
                commit('setKSK', KSK);
                commit('setKSKLength', setKSKLength);
            }
        },
        async getContract({ commit }, { req }) {
            let Contract = [];
            let setContractLength = 0;
            try {
                const res = await refsService.getContract(req);
                if (!res || !res.successfull) return;
                Contract = res.data.isas_contracts ? res.data.isas_contracts : [];
                if (res.data && res.data.pagination && res.data.pagination.row_count) setContractLength = res.data.pagination.row_count;
            } catch (e) {
                console.error(e);
            } finally {
                commit('setContract', Contract);
                commit('setContractLength', setContractLength);
            }
        }
    }
};
